import { GoalModel } from '../../coaching-base/general';
import { MetricItem } from '../../coaching-tags/models/metric.coaching.model';
import { MetricDataItem } from '../../insight/performance-data/metric.pd.model';
import { CellNode, RowNode, Sort, SortOrder } from '../experimental.grid';

export enum ColumnID {
    METRIC = 'metric',
    ACTUAL = 'actual',
    TARGET = 'target',
    PCT_TARGET = 'pct_target',
    GOAL = 'goal',
    PCT_GOAL = 'pct_goal',
    EXPIRY_DATE = 'expiry_date',
}

export enum TemplateID {
    HEADER = 'header',
    CONTENT = 'content',
}

export interface ColumnContext {
    templateId: TemplateID;
}

export interface RowContext {
    templateId: TemplateID;
}

export interface CellContext {
    templateId: string;
    metric?: MetricItem;
    metricData?: MetricDataItem;
    goalData?: GoalModel;
}

export function compare(
    cellA: CellNode,
    cellB: CellNode,
    rowA: RowNode,
    rowB: RowNode,
    def: Sort,
): number {
    try {
        const mode: 'number' | 'string' =
            def.columnId === ColumnID.METRIC ? 'string' : 'number';
        const ctxA: any = cellA.context.ctx;
        const ctxB: any = cellB.context.ctx;
        let valA: any;
        let valB: any;
        switch (def.columnId) {
            case ColumnID.METRIC:
                // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
                valA = ctxA.metric && ctxA.metric.name;
                // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
                valB = ctxB.metric && ctxB.metric.name;
                break;
            // TODO others
            default:
                console.error('invalid column');
                return Number.MIN_SAFE_INTEGER;
        }
        if (mode === 'number') {
            valA = valA == null ? Number.MIN_SAFE_INTEGER : valA;
            valB = valB == null ? Number.MIN_SAFE_INTEGER : valB;
        } else {
            valA = valA == null ? '' : valA;
            valB = valB == null ? '' : valB;
        }
        return mode === 'number'
            ? def.order === SortOrder.ASC
                ? valA - valB
                : valB - valA
            : def.order === SortOrder.ASC
            ? valA.localeCompare(valB)
            : valB.localeCompare(valA);
    } catch (e) {
        console.log(e);
        return Number.MIN_SAFE_INTEGER;
    }
}
